module.exports = __webpack_public_path__ + "media/images/cliparts/Home improvement 1-31d435030027ad71f33c2dd185c8298a.svg";